import * as React from 'react'
import Dlg from './Dlg'
import { Typography } from '@mui/material'
import { type MouseEventHandler } from 'react'

interface PaymentPastDueDlgProps {
  open: boolean
  handleClose: MouseEventHandler<HTMLButtonElement>
  handleMode: any
  cancelPlanReason: any
  isWarning?: boolean
}

const PaymentPastDueDlg: React.FC<PaymentPastDueDlgProps> = ({ open, handleClose, handleMode, cancelPlanReason, isWarning }) => {
  return (
    <Dlg name='Payment Past Due' open={open} handleClose={handleClose} cancelBtnText={'Not Right Now'} okBtnText={'Update Payment'} showBtn={true} handleSubmit={handleMode} disabled={cancelPlanReason === ''} isWarning={isWarning}>
      <>
      <Typography variant='subtitle2' sx={{ my: 4 }}>
        Your content plan subscription payment is past due, and will be cancelling soon. Please click through to update your payment information.
      </Typography>
      </>
    </Dlg>
  )
}

export default PaymentPastDueDlg
